import { CANCEL_APPLICATION_MANAGER_IDV_REQUEST, REQUEST_APPLICATION_MANAGER_TO_IDV } from '../constants/actions';

const initialState = false;

export default function requestIdVerificationModalIsOpen(state = initialState, action) {
  switch (action.type) {
    case REQUEST_APPLICATION_MANAGER_TO_IDV:
      return true;
    case CANCEL_APPLICATION_MANAGER_IDV_REQUEST:
      return false;
    default:
      return state;
  }
}
